import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 px-4 relative" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-invert prose-lg md:prose-xl mx-auto text-slate-300" data-id="element-78">
          <p className="italic text-2xl md:text-3xl text-white font-medium leading-relaxed border-l-4 border-blue-500 pl-6 mb-8" data-id="element-79">
            "Son las 11:45 PM y estás actualizando el Administrador de Anuncios
            por décima vez. Los números están en rojo, el CPM sube y, aunque
            tienes clics, nadie compra."
          </p>

          <p className="leading-[1.8]" data-id="element-80">
            Sientes que estás apostando en un casino en lugar de invertir en un
            negocio. El nudo en tu estómago es real: sabes que tu segmentación
            por "intereses" ya no funciona, pero no sabes qué otra cosa hacer.
          </p>
        </motion.div>
      </div>
    </section>;
}